import { FUNNEL_SECTIONS } from "../../config/steps";

export function ProgressBar({ currentStep }) {
  // Find current section
  const currentSection = FUNNEL_SECTIONS.find((section) =>
    section.steps.includes(currentStep),
  );

  const getCurrentSectionProgress = () => {
    if (!currentSection) return 0;

    const sectionSteps = currentSection.steps;
    const currentStepIndex = sectionSteps.indexOf(currentStep);
    // Calculate progress as a percentage
    return ((currentStepIndex + 1) / sectionSteps.length) * 100;
  };

  const getCurrentSectionIndex = () => {
    return FUNNEL_SECTIONS.findIndex((section) =>
      section.steps.includes(currentStep),
    );
  };

  return (
    <div className="px-4 py-2">
      {/* Progress bar */}
      <div className="flex h-2 gap-1">
        {FUNNEL_SECTIONS.map((section, index) => {
          const isCurrentSection = section === currentSection;
          const isPastSection = index < getCurrentSectionIndex();

          return (
            <div
              key={section.id}
              className="h-full flex-1 rounded-full overflow-hidden bg-gray-200"
            >
              <div
                className={`h-full transition-all duration-300 rounded-full bg-green-500`}
                style={{
                  width: isPastSection
                    ? "100%"
                    : isCurrentSection
                      ? `${getCurrentSectionProgress()}%`
                      : "0%",
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
